import React, { useEffect, useState, useRef } from 'react';
import cx from 'classnames';
import { Switch, Route, Redirect, NavLink } from 'react-router-dom';

// @material-ui/core components
import { withStyles, makeStyles } from '@material-ui/core/styles';
import EmojiTransportationTwoToneIcon from '@material-ui/icons/EmojiTransportationTwoTone';
import BallotTwoToneIcon from '@material-ui/icons/BallotTwoTone';
import AccountTreeTwoToneIcon from '@material-ui/icons/AccountTreeTwoTone';

// core components
import * as AuthService from '../core/auth/auth-actions';
import { SidebarLayout, PrivateRoute, PublicRoute } from '@intervan-ar/ov-componentes';
import mainRoutes from '../routes/main';
import { getLogo } from '../core/params.js';
import ServiceOffline from './ServiceOffline.js';
import { browserHistory, getFullUrl } from '../core/globals';
import { useSelector, useDispatch } from 'react-redux';
import {
  setConsultaDinamica,
  setParseoPrivadas,
  setParseoPublicas
} from '../core/consultaDinamica/consultaDinamica-actions';

// Style
import style from './MainLayoutStyle';

const useStyles = makeStyles(style);

const roleAccessor = "perfiles";

const MainLayout = props => {
  const dispatch = useDispatch();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [miniActive, setMiniActive] = useState(false);
  const [logo, setLogo] = useState(null);
  const mainPanelRef = useRef(null);
  const parametros = useSelector(state => {
    return state.parametros.data;
  });
  const system = useSelector(state => {
    return state.system;
  });
  const extraClasses = useStyles();

  const user = useSelector(state => {
    return state.auth.user;
  });
  const loading = useSelector(state => {
    return state.auth.loadingUser;
  });
  const initialMessage = useSelector(state => {
    return state.auth.showInitialMessage;
  });
  const popUpLogin = useSelector(state => {
    return state.auth.popUpLogin ? state.auth.popUpLogin : false;
  });
  const consultasSlice = useSelector(state => {
    return state.consultasDinamicas;
  });
  const {
    consultas: consultasDinamicas,
    parseoPrivadas: privadasParseadas,
    parseoPublicas: publicasParseadas,
  } = consultasSlice;
  const rutas = mainRoutes(parametros, consultasDinamicas);

  useEffect(() => {
    let listaConsultasDinamicas = [];
    if(Object.hasOwn(user, "nombre")  && !privadasParseadas && parametros?.OV_DEUDA_CONSULTAS_DINAMICAS?.valor !== undefined) {
      try {
        let consultasConLogin = JSON.parse(parametros?.OV_DEUDA_CONSULTAS_DINAMICAS?.valor);
        const consultasPrivadas = consultasConLogin.consultas.map((c) => {
          if(c.collapse && Array.isArray(c.views)) {
            return {
              ...c,
              private: true,
              public: false,
              views: c.views.map((s) => {
                return {
                  ...s,
                  private: true,
                  public: false,
                };
              }),
            }
          }
          return {
            ...c,
            private: true,
            public: false
          };
        });
        listaConsultasDinamicas.push(...consultasPrivadas);
      }
      catch(error) {
        console.log("Error al cargar consultas con login");
      }
      dispatch(setParseoPrivadas(true));
      console.log(`parseó privadas`);
    }

    if(!Object.hasOwn(user, "nombre") && !publicasParseadas && parametros?.OV_DEUDA_CONSULTAS_SIN_LOGIN?.valor !== undefined) {
      try {
        let consultasSinLogin = JSON.parse(parametros?.OV_DEUDA_CONSULTAS_SIN_LOGIN?.valor);
        const consultasPublicas = consultasSinLogin.consultas.map((c) => {
          if(c.collapse && Array.isArray(c.views)) {
            return {
              ...c,
              private: false,
              public: true,
              views: c.views.map((s) => {
                return {
                  ...s,
                  private: false,
                  public: true
                };
              }),
            }
          }
          return {
            ...c,
            private: false,
            public: true
          };
        });
        listaConsultasDinamicas.push(...consultasPublicas);
      }
      catch(error) {
        console.log(`Error al cargar consultas sin login`);
      }
      dispatch(setParseoPublicas(true));
      console.log(`parseó públicas`);
    }

    if(listaConsultasDinamicas.length > 0) {
      dispatch(setConsultaDinamica(listaConsultasDinamicas));
    }
  }, [
    parametros.OV_DEUDA_CONSULTAS_DINAMICAS,
    parametros.OV_DEUDA_CONSULTAS_SIN_LOGIN,
    consultasDinamicas,
    user,
    dispatch
  ]);

  useEffect(() => {
    let unmounted = false;
    const init = async () => {
      try {
      var logo = await getLogo();
      }
      catch(error) {
        console.log("Error al obtener logo");
      }
      if(!unmounted) setLogo(logo);

      window.addEventListener('resize', resizeFunction);
    };
    init();
    return () => {
      window.removeEventListener('resize', resizeFunction);
    };
  }, []);

  useEffect(() => {
    if (props.history.location.pathname !== props.location.pathname) {
      mainPanelRef.current.scrollTop = 0;
      if (mobileOpen) {
        setMobileOpen(false);
      }
    }
  }, [props.history, props.location, mobileOpen]);

  const handleDrawerToggle = () => {
    if (window.innerWidth <= 960) {
      setMobileOpen(!mobileOpen);
    }
  };

  const sidebarMinimize = () => {
    setMiniActive(!miniActive);
  };

  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
    else {
      setMiniActive(false);
    }
  };

  const renderRoutes = () => {
    const componentProps = {
      headerProps: {
        sidebarMinimize: sidebarMinimize,
        miniActive: miniActive,
        routes: rutas,
        handleDrawerToggle: handleDrawerToggle,
        location: props.location,
      },
    };

    return (
      <Switch>
        {rutas.map((prop, key) => {
          if (!prop?.views) {
            if (prop.redirect)
              return <Redirect from={prop.path} to={prop.pathTo} key={key} />;
            if (prop.private)
              return (
                <PrivateRoute
                  path={prop.path}
                  component={prop.component}
                  key={key}
                  componentProps={componentProps}
                  authService={AuthService}
                  routeComponent={Route}
                  redirectComponent={Redirect}
                  redirectTo={getFullUrl('inicio')}
                  useDispatch={dispatch}
                  route={prop}
                  roleAccessor={roleAccessor}
                  user={user}
                />
              );
            if (prop.public)
              return (
                <PublicRoute
                  path={prop.path}
                  component={prop.component}
                  key={key}
                  componentProps={componentProps}
                  routeComponent={Route}
                />
              );
            return (
              <Route path={prop.path} component={prop.component} key={key} />
            );
          } else {
            const { views } = prop;

            return views.map((route, i) => (
              <PrivateRoute
                path={route.path}
                component={route.component}
                key={i}
                componentProps={componentProps}
                authService={AuthService}
                routeComponent={Route}
                useDispatch={dispatch}
                redirectComponent={Redirect}
                redirectTo={getFullUrl('inicio')}
                route={route}
                roleAccessor={roleAccessor}
                user={user}
              />
            ));
          }
        })}
      </Switch>
    );
  };

  const opcionCuentas = {
    mostrar: true,
    descripcion: "Mis cuentas",
    iconoCuentas: parametros.REACT_APP_MENU_ICON_CUENTAS &&
      parametros.REACT_APP_MENU_ICON_CUENTAS.valor ===
        'municipios' ? (
        <EmojiTransportationTwoToneIcon />
      ) : parametros.REACT_APP_MENU_ICON_CUENTAS &&
        parametros.REACT_APP_MENU_ICON_CUENTAS.valor ===
          'creditos' ? (
        <BallotTwoToneIcon />
      ) : (
        <AccountTreeTwoToneIcon />
      ),
  };

  const { classes, ...rest } = props;
  const mainPanel =
    classes.mainPanel +
    ' ' +
    cx({
      [classes.mainPanelSidebarMini]: miniActive
    });

  if (system && system.systemOffline) {
    if (
      browserHistory.location.pathname !==
      `${process.env.REACT_APP_BASE_URL}inicio`
    )
      browserHistory.push(getFullUrl('inicio'));
    else return <ServiceOffline />;
  }

  return (
    <div className={classes.wrapper}>
      <SidebarLayout
        routes={rutas}
        logo={logo}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color="purple"
        bgColor="white"
        miniActive={miniActive}
        user={user}
        loading={loading}
        popUpLogin={popUpLogin}
        initialMessage={initialMessage}
        parametros={parametros}
        getFullUrl={getFullUrl}
        authService={AuthService}
        dispatch={dispatch}
        onMyProfile={() => {props.history.replace(getFullUrl('my-profile'));}}
        history={props.history}
        navLinkComponent={NavLink}
        opcionCuentas={opcionCuentas}
        roleAccessor={roleAccessor}
        {...rest}
      />
      <div id="mainScrollAnchor" className={mainPanel} ref={mainPanelRef}>
        {renderRoutes()}
      </div>
    </div>
  );
};

export default (withStyles(style)(MainLayout));
